"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_vue_1 = require("./src/index.vue");
exports.default = index_vue_1.default;
